import axios from 'axios';
import env from '../env';

const API_BASE_URL = env.API_URL;
const SIGNALR_HUB_URL = env.SIGNALR_URL;

export const sendComMessage = async (token: string, formData:any) => {
    try {
        const response = await axios.post(`${API_BASE_URL}Community/messages`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getComMessages = async (token: string, userId: any, userType: any) => {
    try {
        const response = await axios.get(`${API_BASE_URL}Community/messages?userId=${userId}&userType=${userType}&take=50`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getCommunityUnreadCount = async (token: string, userId: any, userType: any) => {
    try {
        const response = await axios.get(`${API_BASE_URL}Community/unread-count?userId=${userId}&userType=${userType}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const markCommunityMessagesAsRead = async (token: string, userId: any, userType: any, lastReadMessageId: number = 0) => {
    try {
        const response = await axios.post(`${API_BASE_URL}Community/messages/read`, {
            userId: Number(userId),
            userType: Number(userType),
            lastReadMessageId: lastReadMessageId
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
  